import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkArea } from "src/models/HumanResources/WorkAreas.models";

interface WorkAreaState {
  workAreas: IWorkArea[];
  workAreaToEdit: IWorkArea | null;
}

const initialState: WorkAreaState = {
  workAreas: [],
  workAreaToEdit: null,
};

const WorkAreaSlice = createSlice({
  name: "WorkArea",
  initialState,
  reducers: {
    setWorkAreaList: (state, action: PayloadAction<IWorkArea[]>) => {
      state.workAreas = action.payload;
    },
    concatListWorkArea: (
      state: WorkAreaState,
      action: PayloadAction<IWorkArea[]>
    ) => {
      state.workAreas = [...state.workAreas.concat(action.payload)];
    },
    setWorkAreaToEdit: (state, action: PayloadAction<IWorkArea | null>) => {
      state.workAreaToEdit = action.payload;
    },
    addWorkArea: (state, action: PayloadAction<IWorkArea>) => {
      state.workAreas.push(action.payload);
    },
    updateWorkArea: (state, action: PayloadAction<IWorkArea>) => {
      let itemIndex = state.workAreas.findIndex(
        item => item.workAreaId === action.payload.workAreaId
      );
      if (itemIndex !== -1) state.workAreas[itemIndex] = action.payload;
    },
    deleteWorkArea: (state, action: PayloadAction<number>) => {
      const newArray = state.workAreas.filter(
        item => item.workAreaId !== action.payload
      );
      state.workAreas = newArray;
    },
  },
});

export const {
  setWorkAreaList,
  concatListWorkArea,
  setWorkAreaToEdit,
  addWorkArea,
  updateWorkArea,
  deleteWorkArea,
} = WorkAreaSlice.actions;

export default WorkAreaSlice.reducer;
